import { Injectable } from '@angular/core';

import { BrowserService } from '../browser-service/browser.service';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	constructor(private readonly browserService: BrowserService) {}

	/**
	 * Store data in localStorage
	 * @param key Storage key
	 * @param value Data to store
	 */
	public setItem(key: string, value: any): void {
		this.browserService.runInBrowser(() => {
			localStorage.setItem(key, JSON.stringify(value));
		});
	}

	/**
	 * Retrieve data from localStorage
	 * @param key Storage key
	 * @returns Stored data or null if not found
	 */
	public getItem<T>(key: string): T | null {
		let result: T | null = null;
		this.browserService.runInBrowser(() => {
			const item = localStorage.getItem(key);
			result = item ? JSON.parse(item) : null;
		});
		return result;
	}

	/**
	 * Remove specific item from localStorage
	 * @param key Storage key
	 */
	public removeItem(key: string): void {
		this.browserService.runInBrowser(() => {
			localStorage.removeItem(key);
		});
	}

	/**
	 * Clear all data from localStorage
	 */
	public resetLocalStorage(): void {
		this.browserService.runInBrowser(() => {
			localStorage.clear();
		});
	}

	/**
	 * Check if key exists in localStorage
	 * @param key Storage key
	 * @returns boolean indicating if key exists
	 */
	public isKeyExists(key: string): boolean {
		let result = null;
		this.browserService.runInBrowser(() => {
			result = localStorage.getItem(key) !== null;
		});
		return result;
	}
}
